import { Component } from '@angular/core';
import {HttpClientService} from "../../../../core/services/http-client.service";
import {CommonService} from "../../../../core/services/common.service";
import {ToastService} from "../../../../core/services/toast.service";
import {Router, Routes} from "@angular/router";

@Component({
  selector: 'app-recently-order',
  templateUrl: './recently-order.component.html',
  styleUrls: ['./recently-order.component.css']
})
export class RecentlyOrderComponent {
  data: any;
  loader: boolean = false;
  loading = false;
  orders: any[]=[];
  user: any;

  constructor(private http: HttpClientService, private router: Router, private common: CommonService, private toast: ToastService) {}
  ngOnInit(): void {
    this.user = this.common.getStorage('customer');
    this.getUserAddresses(this.user.id);
  }

  private getUserAddresses(userID) {
    this.http.get(`store/order?id=${userID}&offset=0&limit=5`)
      .subscribe((res) => {
        if (res.statusCode == 200) this.orders = res.response;
      });
  }

  navigateToOrderDetails(order: any): void {
    this.router.navigate(['/user/profile/orders/', order.id]);
  }
  redirectToShop() {
    this.router.navigate([`/`]);
  }
  downloadInvoice(order){
    this.http.downloadFile("store/generateInvoice?orderId="+order.itemId,'application/pdf')
      .subscribe((blob:any) => {
        this.loader = false;
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = order.itemId+`-invoice.pdf`;
        link.click();
      }, error => {
        this.loader = false;
        if (error.statusCode == 400) {
          this.toast.error(error.response.message)
        } else {
          this.toast.error("Something went wrong")
        }
      });
  }
}
